<template>
  <div
    :class="{ adv: type == 'adv', pro: type == 'pro', bns: type == 'bns' }"
    :style="{
      width: size === 'big' ? '47px' : '34px',
      height: size === 'big' ? '21px' : '14.6px',
    }"
  />
</template>

<script>
export default {
  name: "member-tag",
  props: {
    type: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "mini",
    },
  },
};
</script>

<style lang="less" scoped>
.adv,
.pro,
.bns {
  display: inline-block;
  width: 34px;
  height: 14.6px;
  margin-left: 10px;
  margin-top: 6px;
}
.adv {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/img_vip_adv_big.png);
  background-size: 100%;
}
.pro {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/img_vip_pro_big.png);
  background-size: 100%;
}
.bns {
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/img_vip_bns_big.png);
  background-size: 100%;
}
</style>